module.exports = __webpack_public_path__ + "images/gwt-sticky-banner.jpg";